import axiosClient from '@/core/axiosClient'
const resource = '/api/employee'

export default {
  async getEmployeeInfo () {
    try {
      const response = await axiosClient.get(`${resource}/info/`)

      // Behandle svaret, når der er en forbindelse
      return { state: 'success', data: response.data }
    } catch (error: any) {
      if (error.message === 'Network Error') {
        // Håndter offline-tilstand
        console.log('Offline-tilstand: Ingen netværksforbindelse')
        return { state: 'offline', data: null }
      } else {
        // Håndter andre fejl
        console.error('Fejl under anmodning:', error.message)
        return { state: 'error', data: null }
      }
    }
  }
}
